import React from "react";
import SearchBar from "../ui/SearchBar";
import { CandidateRow } from "../../helpers/housingAssignment";

interface CandidateSearchPanelState {
  placeholder: string;
  search: string;
  onSearchChange: (text: string) => void;
  rows: CandidateRow[];
  onPick: (row: CandidateRow) => void;
  emptyText: string;
}

const CandidateSearchPanel = ({ placeholder, search, onSearchChange, rows, onPick, emptyText }: CandidateSearchPanelState) => {
  return (
    <div className="p-2 bg-white border rounded mt-2">
      <SearchBar cssClass="mb-2" placeholder={placeholder} searchText={search} setSearchText={onSearchChange} searchLogic={() => {}} />
      {/* p-1 is not spacing: overflow-auto clips at this box, and the focus ring on a row is
          drawn 4px outside it. Without the padding the first row shows only its bottom edge
          and the rest lose their left and right. */}
      <div className="overflow-auto p-1" style={{ maxHeight: 260 }}>
        {rows.length === 0 ? (
          <p className="text-muted small mb-0 px-1">{emptyText}</p>
        ) : (
          rows.map((row) => (
            <div
              key={row.id}
              // assigning someone is the whole point of this panel, so it has to be reachable
              // without a mouse - and a blocked row has to say so to a screen reader, not only
              // through a dimmed colour
              role="button"
              tabIndex={row.selectable ? 0 : -1}
              aria-disabled={!row.selectable}
              className={`candidate-row p-2 rounded ${row.selectable ? "cursor-pointer" : "opacity-75"}`}
              style={row.selectable ? undefined : { cursor: "not-allowed" }}
              onClick={row.selectable ? () => onPick(row) : undefined}
              onKeyDown={
                row.selectable
                  ? (e: React.KeyboardEvent) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onPick(row);
                      }
                    }
                  : undefined
              }
            >
              <div>
                <span className="fw-semibold small">{row.name}</span>
                {row.sizeLabel && <span className="text-muted small ms-1">{row.sizeLabel}</span>}
              </div>
              {row.note && <div className={`small ${row.noteClass}`}>{row.note}</div>}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CandidateSearchPanel;
